import { NgZone } from '@angular/core';
import { Observable, UnaryFunction } from 'rxjs';

export const rxNgZoneRun = <T>(
  zone: NgZone,
): UnaryFunction<Observable<T>, Observable<T>> => {
  return (source: Observable<T>) => {
    return new Observable<T>((observer) => {
      // Helper function to run callback in zone
      const runInZone = (callback: () => void) => {
        zone.run(callback);
      };

      // Subscribe to the source with zone-aware handlers
      return source.subscribe({
        next: (value: T) => {
          runInZone(() => observer.next(value));
        },
        error: (error: any) => {
          runInZone(() => observer.error(error));
        },
        complete: () => {
          runInZone(() => observer.complete());
        },
      });
    });
  };
};
